export enum AuthorityVision {
  MOVIMENTATION_WORKORDER_VISION = '18.1',
}

export const T = {
  ...AuthorityVision,
};
